import { dateFormat, dayJs, objectToGet } from '../../functions/index'
import closingDay from '../../const/_closing-day'
import dayjs from 'dayjs'

/**
 * Config // Configの定義
 *
 * @returns {undefined}
 */

class ConfigForm {
  init() {
    const cDay = objectToGet(closingDay, '0.day', 14)
    // const cDayEndDatetime = objectToGet(closingDay, '2.endDaytime', dayjs())
    // if (dayjs().isBefore(dayjs(cDayEndDatetime))) {
    //   // 手仕舞日自動制御ON
    //   cDay = objectToGet(closingDay, '2.day', 14)
    // }
    try {
      if (direct_config.stayDays === undefined) direct_config.stayDays = 5
      if (direct_config.departureCode === undefined) direct_config.departureCode = 'none'
      if (direct_config.areaCode === undefined) direct_config.areaCode = 'none'
      if (direct_config.countryCode === undefined) direct_config.countryCode = 'none'
      if (direct_config.cityCode === undefined) direct_config.cityCode = 'none'
      if (direct_config.departureDate === undefined) {
        direct_config.departureDate = dayJs().add(cDay, 'day').format('YYYY-MM-DD')
      } else {
        direct_config.departureDate = dayJs(dateFormat(direct_config.departureDate, 'YYYY-MM-DD'))
      }
      return direct_config
    } catch (error) {
      let direct_config = {
        stayDays: 'none',
        departureCode: 'none',
        areaCode: 'none',
        countryCode: 'none',
        cityCode: 'none',
        departureDate: dayJs().add(cDay, 'day').format('YYYY-MM-DD')
      }
      return direct_config
    }
  }
}
export default new ConfigForm()
